module.exports = __webpack_public_path__ + "static/media/fee-icon.39ea6c35.svg";